import bs58 from 'bs58';
import nacl from 'tweetnacl';

export type NaClKeyPair = {
  publicKey: string;
  secretKey: string;
};

/**
 * Generates a new NaCl key pair for encryption.
 *
 * @returns A key pair with base58-encoded public and secret keys
 */
export const generateNaClKeyPair = (): NaClKeyPair => {
  const keyPair = nacl.box.keyPair();

  return {
    publicKey: bs58.encode(keyPair.publicKey),
    secretKey: bs58.encode(keyPair.secretKey),
  };
};
